import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=4401e026&scoped=true"
import script from "./CustomFileInput.vue?vue&type=script&lang=js"
export * from "./CustomFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4401e026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VChip,VFileInput})
